const swapVideo = function() {
  jQuery('video[data-mobile],video[data-desktop]').each(function() {
    var $this = jQuery(this);
    var br = $this.data('break');
    var mobile = $this.attr('data-mobile');
    var desktop = $this.attr('data-desktop');
    var src = $this.attr('src');
    if(br && window.innerWidth < parseFloat(br) && mobile && src != mobile) {
      $this.prop('src', mobile);
    } else if(br && window.innerWidth >= parseFloat(br) && desktop && src != desktop) {
      $this.prop('src', desktop);
    }
  });
};

jQuery(document).ready(swapVideo);
jQuery(function($) {
  $(window).on('resize', debounce(swapVideo, 250));
});